// extracted by mini-css-extract-plugin
export default {"Up":"HinzufügenRegeln_Up__OQat1","GR":"HinzufügenRegeln_GR__Yf4Ll","EN":"HinzufügenRegeln_EN__S0ufS"};